var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2152_19599)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.82495 16.2003L5.5174 12.7003C5.14885 12.3103 4.56294 12.3103 4.19439 12.7003C3.82583 13.0903 3.82583 13.7103 4.19439 14.1003L8.15399 18.2903C8.52255 18.6803 9.11791 18.6803 9.48646 18.2903L19.5036 7.70031C19.8722 7.31031 19.8722 6.69031 19.5036 6.30031C19.135 5.91031 18.5491 5.91031 18.1806 6.30031L8.82495 16.2003Z",
    fill: "#02E023"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2152_19599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.6803,
    height: 24,
    fill: "white",
    transform: "translate(0.320312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.307b206407026a740380db20df50e7c4.svg";
export { ForwardRef as ReactComponent };